// extracted by mini-css-extract-plugin
export default {"arrowLink":"ArrowLink_arrowLink__adXiW"};